import getRecurrenceFromList from '@/services/api/internal/eDispatch/recurrence.api';

function treatRecurrenceResponse(recurrenceList) {
  return recurrenceList.map((recurrence) => ({
    ...recurrence,
    recurrence: !!recurrence && recurrence.requests_number > 1,
  }));
}

export default function getRecurrenceInfos(items) {
  let idList = items.map((item) => item.property_id);
  idList = idList.filter(
    (item, index) => idList.findIndex((id) => id === item) === index
  );
  return getRecurrenceFromList(idList).then((recurrenceList) =>
    treatRecurrenceResponse(recurrenceList)
  );
}
